import React from "react";

export default function Alert({ details }) {
  return (
    <div>
      <div class={`alert alert-${details.status}`} role="alert">
        {details.message}

        {details.buttonStatus ? (
          <a
            style={{
              background: "#00aaef",
              color: "white",
              paddingLeft: "20px",
              paddingRight: "20px",
              paddingTop: "10px",
              paddingBottom: "10px",
              borderRadius: "26px",
              marginLeft: "5px",
            }}
            href={details.routeName}
          >
            My Profile
          </a>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}
